<script>
export default {
  namespaced: true,
  state: {
    ivent_id: "",
    target_Delete: {},
    target_Edit: {},
    total_price: 0,
    selected_productlist: {}
  },
  mutations: {
    set_ivent_id(state, current_ivent_id) {
      state.ivent_id = current_ivent_id;
    },
    set_Delete(state, want_Delete_Product) {
      vm.$set(state.target_Delete, "product_id", want_Delete_Product.id);
      vm.$set(state.target_Delete, "name", want_Delete_Product.data().name);
    },
    set_Edit(state, want_Edit_Product) {
      vm.$set(state.target_Edit, "product_id", want_Edit_Product.id);
      vm.$set(state.target_Edit, "name", want_Edit_Product.data().name);
      vm.$set(state.target_Edit, "price", want_Edit_Product.data().price);
    },
    set_Price(state, pay_price) {
      state.total_price += pay_price;
    },
    init_Price(state) {
      state.total_price = 0;
    },
    set_Productlist(state, want_Select_Product) {
      this.$set(
        state.selected_productlist,
        want_Select_Product.id,
        want_Select_Product
      );
    }
  },
  actions: {
    display_Product_List({ commit }, current_ivent_id) {
      commit("set_ivent_id", current_ivent_id);
    },
    display_Delete({ commit }, target_Delete_Product) {
      commit("set_Delete", target_Delete_Product);
    },
    display_Edit({ commit }, target_Edit_Product) {
      commit("set_Edit", target_Edit_Product);
    },
    display_Total_Price({ commit }, target_Product) {
      commit("set_Price", target_Product.pay_price);
      //commit("set_Productlist", target_Product.detail);
    },
    init_Total_Price({ commit }) {
      commit("init_Price");
    }
  },
  getters: {
    total_price(state) {
      return state.total_price;
    },
    ivent_id(state) {
      return state.ivent_id;
    },
    delete(state) {
      return state.target_Delete;
    },
    edit(state) {
      return state.target_Edit;
    }
  }
};
</script>
